module.exports = __webpack_public_path__ + "media/images/logos/navico-9bd33f3f50229edbedcf4cdc8d7e73f1.png";